/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as PublicRouteImport } from './routes/_public'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as PublicAcceptInviteRouteImport } from './routes/_public/accept-invite'
import { Route as PublicChooseOrgRouteImport } from './routes/_public/choose-org'
import { Route as PublicCreateOrgRouteImport } from './routes/_public/create-org'
import { Route as PublicForgotPasswordRouteImport } from './routes/_public/forgot-password'
import { Route as PublicLegalRouteImport } from './routes/_public/legal'
import { Route as PublicLoginRouteImport } from './routes/_public/login'
import { Route as PublicMaintenanceRouteImport } from './routes/_public/maintenance'
import { Route as PublicMfaRouteImport } from './routes/_public/mfa'
import { Route as PublicResetPasswordRouteImport } from './routes/_public/reset-password'
import { Route as PublicSessionExpiredRouteImport } from './routes/_public/session-expired'
import { Route as PublicSignupRouteImport } from './routes/_public/signup'
import { Route as PublicSsoRouteImport } from './routes/_public/sso'
import { Route as PublicStatusRouteImport } from './routes/_public/status'
import { Route as PublicVerifyEmailRouteImport } from './routes/_public/verify-email'
import { Route as AppBillingIndexRouteImport } from './routes/_app/billing/index'
import { Route as AppBillingCancelRouteImport } from './routes/_app/billing/cancel'
import { Route as AppBillingCheckoutRouteImport } from './routes/_app/billing/checkout'
import { Route as AppBillingCreditsRouteImport } from './routes/_app/billing/credits'
import { Route as AppBillingDetailsRouteImport } from './routes/_app/billing/details'
import { Route as AppBillingInvoicesRouteImport } from './routes/_app/billing/invoices'
import { Route as AppBillingPaymentMethodsRouteImport } from './routes/_app/billing/payment-methods'
import { Route as AppBillingPlansRouteImport } from './routes/_app/billing/plans'
import { Route as AppConnectAgentRouteImport } from './routes/_app/connect/agent'
import { Route as AppConnectApiGatewayRouteImport } from './routes/_app/connect/api-gateway'
import { Route as AppConnectImportRouteImport } from './routes/_app/connect/import'
import { Route as AppConnectIngestionRouteImport } from './routes/_app/connect/ingestion'
import { Route as AppConnectIntegrationsRouteImport } from './routes/_app/connect/integrations'
import { Route as AppConnectMcpRouteImport } from './routes/_app/connect/mcp'
import { Route as AppConnectModelsRouteImport } from './routes/_app/connect/models'
import { Route as AppConnectRoutingRouteImport } from './routes/_app/connect/routing'
import { Route as AppConnectSourcesRouteImport } from './routes/_app/connect/sources'
import { Route as AppConnectStorageRouteImport } from './routes/_app/connect/storage'
import { Route as AppConnectWebhooksRouteImport } from './routes/_app/connect/webhooks'
import { Route as AppDevelopDocsRouteImport } from './routes/_app/develop/docs'
import { Route as AppDevelopKeysRouteImport } from './routes/_app/develop/keys'
import { Route as AppDevelopPlaygroundRouteImport } from './routes/_app/develop/playground'
import { Route as AppGovernAuditRouteImport } from './routes/_app/govern/audit'
import { Route as AppGovernDeploymentsRouteImport } from './routes/_app/govern/deployments'
import { Route as AppGovernPoliciesRouteImport } from './routes/_app/govern/policies'
import { Route as AppGovernPrivacyRouteImport } from './routes/_app/govern/privacy'
import { Route as AppGovernResidencyRouteImport } from './routes/_app/govern/residency'
import { Route as AppHelpIndexRouteImport } from './routes/_app/help/index'
import { Route as AppHelpContactRouteImport } from './routes/_app/help/contact'
import { Route as AppHelpStatusRouteImport } from './routes/_app/help/status'
import { Route as AppHelpWhatsNewRouteImport } from './routes/_app/help/whats-new'
import { Route as AppMeAccessRouteImport } from './routes/_app/me/access'
import { Route as AppMeDataRouteImport } from './routes/_app/me/data'
import { Route as AppMeMemoryRouteImport } from './routes/_app/me/memory'
import { Route as AppMeNotificationPreferencesRouteImport } from './routes/_app/me/notification-preferences'
import { Route as AppMeNotificationsRouteImport } from './routes/_app/me/notifications'
import { Route as AppMeProfileRouteImport } from './routes/_app/me/profile'
import { Route as AppMeSecurityRouteImport } from './routes/_app/me/security'
import { Route as AppOrgBudgetsRouteImport } from './routes/_app/org/budgets'
import { Route as AppOrgMembersRouteImport } from './routes/_app/org/members'
import { Route as AppOrgProductsRouteImport } from './routes/_app/org/products'
import { Route as AppOrgRolesRouteImport } from './routes/_app/org/roles'
import { Route as AppOrgSettingsRouteImport } from './routes/_app/org/settings'
import { Route as AppOrgSsoRouteImport } from './routes/_app/org/sso'
import { Route as AppOrgSupportAccessRouteImport } from './routes/_app/org/support-access'
import { Route as AppOrgUsageRouteImport } from './routes/_app/org/usage'
import { Route as AppOrgWorkspacesRouteImport } from './routes/_app/org/workspaces'
import { Route as AppPlatformIndexRouteImport } from './routes/_app/platform/index'
import { Route as AppPlatformOperationsRouteImport } from './routes/_app/platform/operations'
import { Route as AppPlatformReleasesRouteImport } from './routes/_app/platform/releases'
import { Route as AppPlatformSupportRouteImport } from './routes/_app/platform/support'
import { Route as AppWWsRouteImport } from './routes/_app/w/$ws'
import { Route as AppBillingInvoicesInvoiceIdRouteImport } from './routes/_app/billing/invoices_.$invoiceId'
import { Route as AppConnectSourcesSourceIdRouteImport } from './routes/_app/connect/sources_.$sourceId'
import { Route as AppGovernPrivacyCaseIdRouteImport } from './routes/_app/govern/privacy_.$caseId'
import { Route as AppPlatformTenantsTenantIdRouteImport } from './routes/_app/platform/tenants.$tenantId'
import { Route as AppWWsAccessRouteImport } from './routes/_app/w/$ws/access'
import { Route as AppWWsAgentsRouteImport } from './routes/_app/w/$ws/agents'
import { Route as AppWWsApprovalsRouteImport } from './routes/_app/w/$ws/approvals'
import { Route as AppWWsBranchesRouteImport } from './routes/_app/w/$ws/branches'
import { Route as AppWWsCompactionRouteImport } from './routes/_app/w/$ws/compaction'
import { Route as AppWWsCompanyBrainRouteImport } from './routes/_app/w/$ws/company-brain'
import { Route as AppWWsContextRouteImport } from './routes/_app/w/$ws/context'
import { Route as AppWWsContractsRouteImport } from './routes/_app/w/$ws/contracts'
import { Route as AppWWsExperimentsRouteImport } from './routes/_app/w/$ws/experiments'
import { Route as AppWWsGettingStartedRouteImport } from './routes/_app/w/$ws/getting-started'
import { Route as AppWWsGoalsRouteImport } from './routes/_app/w/$ws/goals'
import { Route as AppWWsKnowledgeRouteImport } from './routes/_app/w/$ws/knowledge'
import { Route as AppWWsLearningRouteImport } from './routes/_app/w/$ws/learning'
import { Route as AppWWsManifestsRouteImport } from './routes/_app/w/$ws/manifests'
import { Route as AppWWsMemoriesRouteImport } from './routes/_app/w/$ws/memories'
import { Route as AppWWsNamespacesRouteImport } from './routes/_app/w/$ws/namespaces'
import { Route as AppWWsOverviewRouteImport } from './routes/_app/w/$ws/overview'
import { Route as AppWWsPeopleRouteImport } from './routes/_app/w/$ws/people'
import { Route as AppWWsProjectionsRouteImport } from './routes/_app/w/$ws/projections'
import { Route as AppWWsProvenanceRouteImport } from './routes/_app/w/$ws/provenance'
import { Route as AppWWsReplayRouteImport } from './routes/_app/w/$ws/replay'
import { Route as AppWWsReviewRouteImport } from './routes/_app/w/$ws/review'
import { Route as AppWWsRootCauseRouteImport } from './routes/_app/w/$ws/root-cause'
import { Route as AppWWsRuntimeRouteImport } from './routes/_app/w/$ws/runtime'
import { Route as AppWWsSessionsRouteImport } from './routes/_app/w/$ws/sessions'
import { Route as AppWWsSettingsRouteImport } from './routes/_app/w/$ws/settings'
import { Route as AppWWsSetupRouteImport } from './routes/_app/w/$ws/setup'
import { Route as AppWWsSimulationsRouteImport } from './routes/_app/w/$ws/simulations'
import { Route as AppWWsSkillsRouteImport } from './routes/_app/w/$ws/skills'
import { Route as AppWWsTracesRouteImport } from './routes/_app/w/$ws/traces'
import { Route as AppWWsBranchesBranchIdRouteImport } from './routes/_app/w/$ws/branches_.$branchId'
import { Route as AppWWsContractsContractIdRouteImport } from './routes/_app/w/$ws/contracts_.$contractId'
import { Route as AppWWsLearningChangeIdRouteImport } from './routes/_app/w/$ws/learning_.$changeId'
import { Route as AppWWsMemoriesMemoryIdRouteImport } from './routes/_app/w/$ws/memories_.$memoryId'
import { Route as AppWWsTracesTraceIdRouteImport } from './routes/_app/w/$ws/traces_.$traceId'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicRoute = PublicRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const PublicAcceptInviteRoute = PublicAcceptInviteRouteImport.update({
  id: '/accept-invite',
  path: '/accept-invite',
  getParentRoute: () => PublicRoute,
} as any)
const PublicChooseOrgRoute = PublicChooseOrgRouteImport.update({
  id: '/choose-org',
  path: '/choose-org',
  getParentRoute: () => PublicRoute,
} as any)
const PublicCreateOrgRoute = PublicCreateOrgRouteImport.update({
  id: '/create-org',
  path: '/create-org',
  getParentRoute: () => PublicRoute,
} as any)
const PublicForgotPasswordRoute = PublicForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => PublicRoute,
} as any)
const PublicLegalRoute = PublicLegalRouteImport.update({
  id: '/legal',
  path: '/legal',
  getParentRoute: () => PublicRoute,
} as any)
const PublicLoginRoute = PublicLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => PublicRoute,
} as any)
const PublicMaintenanceRoute = PublicMaintenanceRouteImport.update({
  id: '/maintenance',
  path: '/maintenance',
  getParentRoute: () => PublicRoute,
} as any)
const PublicMfaRoute = PublicMfaRouteImport.update({
  id: '/mfa',
  path: '/mfa',
  getParentRoute: () => PublicRoute,
} as any)
const PublicResetPasswordRoute = PublicResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => PublicRoute,
} as any)
const PublicSessionExpiredRoute = PublicSessionExpiredRouteImport.update({
  id: '/session-expired',
  path: '/session-expired',
  getParentRoute: () => PublicRoute,
} as any)
const PublicSignupRoute = PublicSignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => PublicRoute,
} as any)
const PublicSsoRoute = PublicSsoRouteImport.update({
  id: '/sso',
  path: '/sso',
  getParentRoute: () => PublicRoute,
} as any)
const PublicStatusRoute = PublicStatusRouteImport.update({
  id: '/status',
  path: '/status',
  getParentRoute: () => PublicRoute,
} as any)
const PublicVerifyEmailRoute = PublicVerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => PublicRoute,
} as any)
const AppBillingIndexRoute = AppBillingIndexRouteImport.update({
  id: '/billing/',
  path: '/billing/',
  getParentRoute: () => AppRoute,
} as any)
const AppBillingCancelRoute = AppBillingCancelRouteImport.update({
  id: '/billing/cancel',
  path: '/billing/cancel',
  getParentRoute: () => AppRoute,
} as any)
const AppBillingCheckoutRoute = AppBillingCheckoutRouteImport.update({
  id: '/billing/checkout',
  path: '/billing/checkout',
  getParentRoute: () => AppRoute,
} as any)
const AppBillingCreditsRoute = AppBillingCreditsRouteImport.update({
  id: '/billing/credits',
  path: '/billing/credits',
  getParentRoute: () => AppRoute,
} as any)
const AppBillingDetailsRoute = AppBillingDetailsRouteImport.update({
  id: '/billing/details',
  path: '/billing/details',
  getParentRoute: () => AppRoute,
} as any)
const AppBillingInvoicesRoute = AppBillingInvoicesRouteImport.update({
  id: '/billing/invoices',
  path: '/billing/invoices',
  getParentRoute: () => AppRoute,
} as any)
const AppBillingPaymentMethodsRoute =
  AppBillingPaymentMethodsRouteImport.update({
    id: '/billing/payment-methods',
    path: '/billing/payment-methods',
    getParentRoute: () => AppRoute,
  } as any)
const AppBillingPlansRoute = AppBillingPlansRouteImport.update({
  id: '/billing/plans',
  path: '/billing/plans',
  getParentRoute: () => AppRoute,
} as any)
const AppConnectAgentRoute = AppConnectAgentRouteImport.update({
  id: '/connect/agent',
  path: '/connect/agent',
  getParentRoute: () => AppRoute,
} as any)
const AppConnectApiGatewayRoute = AppConnectApiGatewayRouteImport.update({
  id: '/connect/api-gateway',
  path: '/connect/api-gateway',
  getParentRoute: () => AppRoute,
} as any)
const AppConnectImportRoute = AppConnectImportRouteImport.update({
  id: '/connect/import',
  path: '/connect/import',
  getParentRoute: () => AppRoute,
} as any)
const AppConnectIngestionRoute = AppConnectIngestionRouteImport.update({
  id: '/connect/ingestion',
  path: '/connect/ingestion',
  getParentRoute: () => AppRoute,
} as any)
const AppConnectIntegrationsRoute = AppConnectIntegrationsRouteImport.update({
  id: '/connect/integrations',
  path: '/connect/integrations',
  getParentRoute: () => AppRoute,
} as any)
const AppConnectMcpRoute = AppConnectMcpRouteImport.update({
  id: '/connect/mcp',
  path: '/connect/mcp',
  getParentRoute: () => AppRoute,
} as any)
const AppConnectModelsRoute = AppConnectModelsRouteImport.update({
  id: '/connect/models',
  path: '/connect/models',
  getParentRoute: () => AppRoute,
} as any)
const AppConnectRoutingRoute = AppConnectRoutingRouteImport.update({
  id: '/connect/routing',
  path: '/connect/routing',
  getParentRoute: () => AppRoute,
} as any)
const AppConnectSourcesRoute = AppConnectSourcesRouteImport.update({
  id: '/connect/sources',
  path: '/connect/sources',
  getParentRoute: () => AppRoute,
} as any)
const AppConnectStorageRoute = AppConnectStorageRouteImport.update({
  id: '/connect/storage',
  path: '/connect/storage',
  getParentRoute: () => AppRoute,
} as any)
const AppConnectWebhooksRoute = AppConnectWebhooksRouteImport.update({
  id: '/connect/webhooks',
  path: '/connect/webhooks',
  getParentRoute: () => AppRoute,
} as any)
const AppDevelopDocsRoute = AppDevelopDocsRouteImport.update({
  id: '/develop/docs',
  path: '/develop/docs',
  getParentRoute: () => AppRoute,
} as any)
const AppDevelopKeysRoute = AppDevelopKeysRouteImport.update({
  id: '/develop/keys',
  path: '/develop/keys',
  getParentRoute: () => AppRoute,
} as any)
const AppDevelopPlaygroundRoute = AppDevelopPlaygroundRouteImport.update({
  id: '/develop/playground',
  path: '/develop/playground',
  getParentRoute: () => AppRoute,
} as any)
const AppGovernAuditRoute = AppGovernAuditRouteImport.update({
  id: '/govern/audit',
  path: '/govern/audit',
  getParentRoute: () => AppRoute,
} as any)
const AppGovernDeploymentsRoute = AppGovernDeploymentsRouteImport.update({
  id: '/govern/deployments',
  path: '/govern/deployments',
  getParentRoute: () => AppRoute,
} as any)
const AppGovernPoliciesRoute = AppGovernPoliciesRouteImport.update({
  id: '/govern/policies',
  path: '/govern/policies',
  getParentRoute: () => AppRoute,
} as any)
const AppGovernPrivacyRoute = AppGovernPrivacyRouteImport.update({
  id: '/govern/privacy',
  path: '/govern/privacy',
  getParentRoute: () => AppRoute,
} as any)
const AppGovernResidencyRoute = AppGovernResidencyRouteImport.update({
  id: '/govern/residency',
  path: '/govern/residency',
  getParentRoute: () => AppRoute,
} as any)
const AppHelpIndexRoute = AppHelpIndexRouteImport.update({
  id: '/help/',
  path: '/help/',
  getParentRoute: () => AppRoute,
} as any)
const AppHelpContactRoute = AppHelpContactRouteImport.update({
  id: '/help/contact',
  path: '/help/contact',
  getParentRoute: () => AppRoute,
} as any)
const AppHelpStatusRoute = AppHelpStatusRouteImport.update({
  id: '/help/status',
  path: '/help/status',
  getParentRoute: () => AppRoute,
} as any)
const AppHelpWhatsNewRoute = AppHelpWhatsNewRouteImport.update({
  id: '/help/whats-new',
  path: '/help/whats-new',
  getParentRoute: () => AppRoute,
} as any)
const AppMeAccessRoute = AppMeAccessRouteImport.update({
  id: '/me/access',
  path: '/me/access',
  getParentRoute: () => AppRoute,
} as any)
const AppMeDataRoute = AppMeDataRouteImport.update({
  id: '/me/data',
  path: '/me/data',
  getParentRoute: () => AppRoute,
} as any)
const AppMeMemoryRoute = AppMeMemoryRouteImport.update({
  id: '/me/memory',
  path: '/me/memory',
  getParentRoute: () => AppRoute,
} as any)
const AppMeNotificationPreferencesRoute =
  AppMeNotificationPreferencesRouteImport.update({
    id: '/me/notification-preferences',
    path: '/me/notification-preferences',
    getParentRoute: () => AppRoute,
  } as any)
const AppMeNotificationsRoute = AppMeNotificationsRouteImport.update({
  id: '/me/notifications',
  path: '/me/notifications',
  getParentRoute: () => AppRoute,
} as any)
const AppMeProfileRoute = AppMeProfileRouteImport.update({
  id: '/me/profile',
  path: '/me/profile',
  getParentRoute: () => AppRoute,
} as any)
const AppMeSecurityRoute = AppMeSecurityRouteImport.update({
  id: '/me/security',
  path: '/me/security',
  getParentRoute: () => AppRoute,
} as any)
const AppOrgBudgetsRoute = AppOrgBudgetsRouteImport.update({
  id: '/org/budgets',
  path: '/org/budgets',
  getParentRoute: () => AppRoute,
} as any)
const AppOrgMembersRoute = AppOrgMembersRouteImport.update({
  id: '/org/members',
  path: '/org/members',
  getParentRoute: () => AppRoute,
} as any)
const AppOrgProductsRoute = AppOrgProductsRouteImport.update({
  id: '/org/products',
  path: '/org/products',
  getParentRoute: () => AppRoute,
} as any)
const AppOrgRolesRoute = AppOrgRolesRouteImport.update({
  id: '/org/roles',
  path: '/org/roles',
  getParentRoute: () => AppRoute,
} as any)
const AppOrgSettingsRoute = AppOrgSettingsRouteImport.update({
  id: '/org/settings',
  path: '/org/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppOrgSsoRoute = AppOrgSsoRouteImport.update({
  id: '/org/sso',
  path: '/org/sso',
  getParentRoute: () => AppRoute,
} as any)
const AppOrgSupportAccessRoute = AppOrgSupportAccessRouteImport.update({
  id: '/org/support-access',
  path: '/org/support-access',
  getParentRoute: () => AppRoute,
} as any)
const AppOrgUsageRoute = AppOrgUsageRouteImport.update({
  id: '/org/usage',
  path: '/org/usage',
  getParentRoute: () => AppRoute,
} as any)
const AppOrgWorkspacesRoute = AppOrgWorkspacesRouteImport.update({
  id: '/org/workspaces',
  path: '/org/workspaces',
  getParentRoute: () => AppRoute,
} as any)
const AppPlatformIndexRoute = AppPlatformIndexRouteImport.update({
  id: '/platform/',
  path: '/platform/',
  getParentRoute: () => AppRoute,
} as any)
const AppPlatformOperationsRoute = AppPlatformOperationsRouteImport.update({
  id: '/platform/operations',
  path: '/platform/operations',
  getParentRoute: () => AppRoute,
} as any)
const AppPlatformReleasesRoute = AppPlatformReleasesRouteImport.update({
  id: '/platform/releases',
  path: '/platform/releases',
  getParentRoute: () => AppRoute,
} as any)
const AppPlatformSupportRoute = AppPlatformSupportRouteImport.update({
  id: '/platform/support',
  path: '/platform/support',
  getParentRoute: () => AppRoute,
} as any)
const AppWWsRoute = AppWWsRouteImport.update({
  id: '/w/$ws',
  path: '/w/$ws',
  getParentRoute: () => AppRoute,
} as any)
const AppBillingInvoicesInvoiceIdRoute =
  AppBillingInvoicesInvoiceIdRouteImport.update({
    id: '/billing/invoices_/$invoiceId',
    path: '/billing/invoices/$invoiceId',
    getParentRoute: () => AppRoute,
  } as any)
const AppConnectSourcesSourceIdRoute =
  AppConnectSourcesSourceIdRouteImport.update({
    id: '/connect/sources_/$sourceId',
    path: '/connect/sources/$sourceId',
    getParentRoute: () => AppRoute,
  } as any)
const AppGovernPrivacyCaseIdRoute = AppGovernPrivacyCaseIdRouteImport.update({
  id: '/govern/privacy_/$caseId',
  path: '/govern/privacy/$caseId',
  getParentRoute: () => AppRoute,
} as any)
const AppPlatformTenantsTenantIdRoute =
  AppPlatformTenantsTenantIdRouteImport.update({
    id: '/platform/tenants/$tenantId',
    path: '/platform/tenants/$tenantId',
    getParentRoute: () => AppRoute,
  } as any)
const AppWWsAccessRoute = AppWWsAccessRouteImport.update({
  id: '/access',
  path: '/access',
  getParentRoute: () => AppWWsRoute,
} as any)
const AppWWsAgentsRoute = AppWWsAgentsRouteImport.update({
  id: '/agents',
  path: '/agents',
  getParentRoute: () => AppWWsRoute,
} as any)
const AppWWsApprovalsRoute = AppWWsApprovalsRouteImport.update({
  id: '/approvals',
  path: '/approvals',
  getParentRoute: () => AppWWsRoute,
} as any)
const AppWWsBranchesRoute = AppWWsBranchesRouteImport.update({
  id: '/branches',
  path: '/branches',
  getParentRoute: () => AppWWsRoute,
} as any)
const AppWWsCompactionRoute = AppWWsCompactionRouteImport.update({
  id: '/compaction',
  path: '/compaction',
  getParentRoute: () => AppWWsRoute,
} as any)
const AppWWsCompanyBrainRoute = AppWWsCompanyBrainRouteImport.update({
  id: '/company-brain',
  path: '/company-brain',
  getParentRoute: () => AppWWsRoute,
} as any)
const AppWWsContextRoute = AppWWsContextRouteImport.update({
  id: '/context',
  path: '/context',
  getParentRoute: () => AppWWsRoute,
} as any)
const AppWWsContractsRoute = AppWWsContractsRouteImport.update({
  id: '/contracts',
  path: '/contracts',
  getParentRoute: () => AppWWsRoute,
} as any)
const AppWWsExperimentsRoute = AppWWsExperimentsRouteImport.update({
  id: '/experiments',
  path: '/experiments',
  getParentRoute: () => AppWWsRoute,
} as any)
const AppWWsGettingStartedRoute = AppWWsGettingStartedRouteImport.update({
  id: '/getting-started',
  path: '/getting-started',
  getParentRoute: () => AppWWsRoute,
} as any)
const AppWWsGoalsRoute = AppWWsGoalsRouteImport.update({
  id: '/goals',
  path: '/goals',
  getParentRoute: () => AppWWsRoute,
} as any)
const AppWWsKnowledgeRoute = AppWWsKnowledgeRouteImport.update({
  id: '/knowledge',
  path: '/knowledge',
  getParentRoute: () => AppWWsRoute,
} as any)
const AppWWsLearningRoute = AppWWsLearningRouteImport.update({
  id: '/learning',
  path: '/learning',
  getParentRoute: () => AppWWsRoute,
} as any)
const AppWWsManifestsRoute = AppWWsManifestsRouteImport.update({
  id: '/manifests',
  path: '/manifests',
  getParentRoute: () => AppWWsRoute,
} as any)
const AppWWsMemoriesRoute = AppWWsMemoriesRouteImport.update({
  id: '/memories',
  path: '/memories',
  getParentRoute: () => AppWWsRoute,
} as any)
const AppWWsNamespacesRoute = AppWWsNamespacesRouteImport.update({
  id: '/namespaces',
  path: '/namespaces',
  getParentRoute: () => AppWWsRoute,
} as any)
const AppWWsOverviewRoute = AppWWsOverviewRouteImport.update({
  id: '/overview',
  path: '/overview',
  getParentRoute: () => AppWWsRoute,
} as any)
const AppWWsPeopleRoute = AppWWsPeopleRouteImport.update({
  id: '/people',
  path: '/people',
  getParentRoute: () => AppWWsRoute,
} as any)
const AppWWsProjectionsRoute = AppWWsProjectionsRouteImport.update({
  id: '/projections',
  path: '/projections',
  getParentRoute: () => AppWWsRoute,
} as any)
const AppWWsProvenanceRoute = AppWWsProvenanceRouteImport.update({
  id: '/provenance',
  path: '/provenance',
  getParentRoute: () => AppWWsRoute,
} as any)
const AppWWsReplayRoute = AppWWsReplayRouteImport.update({
  id: '/replay',
  path: '/replay',
  getParentRoute: () => AppWWsRoute,
} as any)
const AppWWsReviewRoute = AppWWsReviewRouteImport.update({
  id: '/review',
  path: '/review',
  getParentRoute: () => AppWWsRoute,
} as any)
const AppWWsRootCauseRoute = AppWWsRootCauseRouteImport.update({
  id: '/root-cause',
  path: '/root-cause',
  getParentRoute: () => AppWWsRoute,
} as any)
const AppWWsRuntimeRoute = AppWWsRuntimeRouteImport.update({
  id: '/runtime',
  path: '/runtime',
  getParentRoute: () => AppWWsRoute,
} as any)
const AppWWsSessionsRoute = AppWWsSessionsRouteImport.update({
  id: '/sessions',
  path: '/sessions',
  getParentRoute: () => AppWWsRoute,
} as any)
const AppWWsSettingsRoute = AppWWsSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppWWsRoute,
} as any)
const AppWWsSetupRoute = AppWWsSetupRouteImport.update({
  id: '/setup',
  path: '/setup',
  getParentRoute: () => AppWWsRoute,
} as any)
const AppWWsSimulationsRoute = AppWWsSimulationsRouteImport.update({
  id: '/simulations',
  path: '/simulations',
  getParentRoute: () => AppWWsRoute,
} as any)
const AppWWsSkillsRoute = AppWWsSkillsRouteImport.update({
  id: '/skills',
  path: '/skills',
  getParentRoute: () => AppWWsRoute,
} as any)
const AppWWsTracesRoute = AppWWsTracesRouteImport.update({
  id: '/traces',
  path: '/traces',
  getParentRoute: () => AppWWsRoute,
} as any)
const AppWWsBranchesBranchIdRoute = AppWWsBranchesBranchIdRouteImport.update({
  id: '/branches_/$branchId',
  path: '/branches/$branchId',
  getParentRoute: () => AppWWsRoute,
} as any)
const AppWWsContractsContractIdRoute =
  AppWWsContractsContractIdRouteImport.update({
    id: '/contracts_/$contractId',
    path: '/contracts/$contractId',
    getParentRoute: () => AppWWsRoute,
  } as any)
const AppWWsLearningChangeIdRoute = AppWWsLearningChangeIdRouteImport.update({
  id: '/learning_/$changeId',
  path: '/learning/$changeId',
  getParentRoute: () => AppWWsRoute,
} as any)
const AppWWsMemoriesMemoryIdRoute = AppWWsMemoriesMemoryIdRouteImport.update({
  id: '/memories_/$memoryId',
  path: '/memories/$memoryId',
  getParentRoute: () => AppWWsRoute,
} as any)
const AppWWsTracesTraceIdRoute = AppWWsTracesTraceIdRouteImport.update({
  id: '/traces_/$traceId',
  path: '/traces/$traceId',
  getParentRoute: () => AppWWsRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/accept-invite': typeof PublicAcceptInviteRoute
  '/choose-org': typeof PublicChooseOrgRoute
  '/create-org': typeof PublicCreateOrgRoute
  '/forgot-password': typeof PublicForgotPasswordRoute
  '/legal': typeof PublicLegalRoute
  '/login': typeof PublicLoginRoute
  '/maintenance': typeof PublicMaintenanceRoute
  '/mfa': typeof PublicMfaRoute
  '/reset-password': typeof PublicResetPasswordRoute
  '/session-expired': typeof PublicSessionExpiredRoute
  '/signup': typeof PublicSignupRoute
  '/sso': typeof PublicSsoRoute
  '/status': typeof PublicStatusRoute
  '/verify-email': typeof PublicVerifyEmailRoute
  '/billing/cancel': typeof AppBillingCancelRoute
  '/billing/checkout': typeof AppBillingCheckoutRoute
  '/billing/credits': typeof AppBillingCreditsRoute
  '/billing/details': typeof AppBillingDetailsRoute
  '/billing/invoices': typeof AppBillingInvoicesRoute
  '/billing/payment-methods': typeof AppBillingPaymentMethodsRoute
  '/billing/plans': typeof AppBillingPlansRoute
  '/connect/agent': typeof AppConnectAgentRoute
  '/connect/api-gateway': typeof AppConnectApiGatewayRoute
  '/connect/import': typeof AppConnectImportRoute
  '/connect/ingestion': typeof AppConnectIngestionRoute
  '/connect/integrations': typeof AppConnectIntegrationsRoute
  '/connect/mcp': typeof AppConnectMcpRoute
  '/connect/models': typeof AppConnectModelsRoute
  '/connect/routing': typeof AppConnectRoutingRoute
  '/connect/sources': typeof AppConnectSourcesRoute
  '/connect/storage': typeof AppConnectStorageRoute
  '/connect/webhooks': typeof AppConnectWebhooksRoute
  '/develop/docs': typeof AppDevelopDocsRoute
  '/develop/keys': typeof AppDevelopKeysRoute
  '/develop/playground': typeof AppDevelopPlaygroundRoute
  '/govern/audit': typeof AppGovernAuditRoute
  '/govern/deployments': typeof AppGovernDeploymentsRoute
  '/govern/policies': typeof AppGovernPoliciesRoute
  '/govern/privacy': typeof AppGovernPrivacyRoute
  '/govern/residency': typeof AppGovernResidencyRoute
  '/help/contact': typeof AppHelpContactRoute
  '/help/status': typeof AppHelpStatusRoute
  '/help/whats-new': typeof AppHelpWhatsNewRoute
  '/me/access': typeof AppMeAccessRoute
  '/me/data': typeof AppMeDataRoute
  '/me/memory': typeof AppMeMemoryRoute
  '/me/notification-preferences': typeof AppMeNotificationPreferencesRoute
  '/me/notifications': typeof AppMeNotificationsRoute
  '/me/profile': typeof AppMeProfileRoute
  '/me/security': typeof AppMeSecurityRoute
  '/org/budgets': typeof AppOrgBudgetsRoute
  '/org/members': typeof AppOrgMembersRoute
  '/org/products': typeof AppOrgProductsRoute
  '/org/roles': typeof AppOrgRolesRoute
  '/org/settings': typeof AppOrgSettingsRoute
  '/org/sso': typeof AppOrgSsoRoute
  '/org/support-access': typeof AppOrgSupportAccessRoute
  '/org/usage': typeof AppOrgUsageRoute
  '/org/workspaces': typeof AppOrgWorkspacesRoute
  '/platform/operations': typeof AppPlatformOperationsRoute
  '/platform/releases': typeof AppPlatformReleasesRoute
  '/platform/support': typeof AppPlatformSupportRoute
  '/w/$ws': typeof AppWWsRouteWithChildren
  '/billing/': typeof AppBillingIndexRoute
  '/help/': typeof AppHelpIndexRoute
  '/platform/': typeof AppPlatformIndexRoute
  '/billing/invoices/$invoiceId': typeof AppBillingInvoicesInvoiceIdRoute
  '/connect/sources/$sourceId': typeof AppConnectSourcesSourceIdRoute
  '/govern/privacy/$caseId': typeof AppGovernPrivacyCaseIdRoute
  '/platform/tenants/$tenantId': typeof AppPlatformTenantsTenantIdRoute
  '/w/$ws/access': typeof AppWWsAccessRoute
  '/w/$ws/agents': typeof AppWWsAgentsRoute
  '/w/$ws/approvals': typeof AppWWsApprovalsRoute
  '/w/$ws/branches': typeof AppWWsBranchesRoute
  '/w/$ws/compaction': typeof AppWWsCompactionRoute
  '/w/$ws/company-brain': typeof AppWWsCompanyBrainRoute
  '/w/$ws/context': typeof AppWWsContextRoute
  '/w/$ws/contracts': typeof AppWWsContractsRoute
  '/w/$ws/experiments': typeof AppWWsExperimentsRoute
  '/w/$ws/getting-started': typeof AppWWsGettingStartedRoute
  '/w/$ws/goals': typeof AppWWsGoalsRoute
  '/w/$ws/knowledge': typeof AppWWsKnowledgeRoute
  '/w/$ws/learning': typeof AppWWsLearningRoute
  '/w/$ws/manifests': typeof AppWWsManifestsRoute
  '/w/$ws/memories': typeof AppWWsMemoriesRoute
  '/w/$ws/namespaces': typeof AppWWsNamespacesRoute
  '/w/$ws/overview': typeof AppWWsOverviewRoute
  '/w/$ws/people': typeof AppWWsPeopleRoute
  '/w/$ws/projections': typeof AppWWsProjectionsRoute
  '/w/$ws/provenance': typeof AppWWsProvenanceRoute
  '/w/$ws/replay': typeof AppWWsReplayRoute
  '/w/$ws/review': typeof AppWWsReviewRoute
  '/w/$ws/root-cause': typeof AppWWsRootCauseRoute
  '/w/$ws/runtime': typeof AppWWsRuntimeRoute
  '/w/$ws/sessions': typeof AppWWsSessionsRoute
  '/w/$ws/settings': typeof AppWWsSettingsRoute
  '/w/$ws/setup': typeof AppWWsSetupRoute
  '/w/$ws/simulations': typeof AppWWsSimulationsRoute
  '/w/$ws/skills': typeof AppWWsSkillsRoute
  '/w/$ws/traces': typeof AppWWsTracesRoute
  '/w/$ws/branches/$branchId': typeof AppWWsBranchesBranchIdRoute
  '/w/$ws/contracts/$contractId': typeof AppWWsContractsContractIdRoute
  '/w/$ws/learning/$changeId': typeof AppWWsLearningChangeIdRoute
  '/w/$ws/memories/$memoryId': typeof AppWWsMemoriesMemoryIdRoute
  '/w/$ws/traces/$traceId': typeof AppWWsTracesTraceIdRoute
}
export interface FileRoutesByTo {
  '/': typeof AppIndexRoute
  '/accept-invite': typeof PublicAcceptInviteRoute
  '/choose-org': typeof PublicChooseOrgRoute
  '/create-org': typeof PublicCreateOrgRoute
  '/forgot-password': typeof PublicForgotPasswordRoute
  '/legal': typeof PublicLegalRoute
  '/login': typeof PublicLoginRoute
  '/maintenance': typeof PublicMaintenanceRoute
  '/mfa': typeof PublicMfaRoute
  '/reset-password': typeof PublicResetPasswordRoute
  '/session-expired': typeof PublicSessionExpiredRoute
  '/signup': typeof PublicSignupRoute
  '/sso': typeof PublicSsoRoute
  '/status': typeof PublicStatusRoute
  '/verify-email': typeof PublicVerifyEmailRoute
  '/billing/cancel': typeof AppBillingCancelRoute
  '/billing/checkout': typeof AppBillingCheckoutRoute
  '/billing/credits': typeof AppBillingCreditsRoute
  '/billing/details': typeof AppBillingDetailsRoute
  '/billing/invoices': typeof AppBillingInvoicesRoute
  '/billing/payment-methods': typeof AppBillingPaymentMethodsRoute
  '/billing/plans': typeof AppBillingPlansRoute
  '/connect/agent': typeof AppConnectAgentRoute
  '/connect/api-gateway': typeof AppConnectApiGatewayRoute
  '/connect/import': typeof AppConnectImportRoute
  '/connect/ingestion': typeof AppConnectIngestionRoute
  '/connect/integrations': typeof AppConnectIntegrationsRoute
  '/connect/mcp': typeof AppConnectMcpRoute
  '/connect/models': typeof AppConnectModelsRoute
  '/connect/routing': typeof AppConnectRoutingRoute
  '/connect/sources': typeof AppConnectSourcesRoute
  '/connect/storage': typeof AppConnectStorageRoute
  '/connect/webhooks': typeof AppConnectWebhooksRoute
  '/develop/docs': typeof AppDevelopDocsRoute
  '/develop/keys': typeof AppDevelopKeysRoute
  '/develop/playground': typeof AppDevelopPlaygroundRoute
  '/govern/audit': typeof AppGovernAuditRoute
  '/govern/deployments': typeof AppGovernDeploymentsRoute
  '/govern/policies': typeof AppGovernPoliciesRoute
  '/govern/privacy': typeof AppGovernPrivacyRoute
  '/govern/residency': typeof AppGovernResidencyRoute
  '/help/contact': typeof AppHelpContactRoute
  '/help/status': typeof AppHelpStatusRoute
  '/help/whats-new': typeof AppHelpWhatsNewRoute
  '/me/access': typeof AppMeAccessRoute
  '/me/data': typeof AppMeDataRoute
  '/me/memory': typeof AppMeMemoryRoute
  '/me/notification-preferences': typeof AppMeNotificationPreferencesRoute
  '/me/notifications': typeof AppMeNotificationsRoute
  '/me/profile': typeof AppMeProfileRoute
  '/me/security': typeof AppMeSecurityRoute
  '/org/budgets': typeof AppOrgBudgetsRoute
  '/org/members': typeof AppOrgMembersRoute
  '/org/products': typeof AppOrgProductsRoute
  '/org/roles': typeof AppOrgRolesRoute
  '/org/settings': typeof AppOrgSettingsRoute
  '/org/sso': typeof AppOrgSsoRoute
  '/org/support-access': typeof AppOrgSupportAccessRoute
  '/org/usage': typeof AppOrgUsageRoute
  '/org/workspaces': typeof AppOrgWorkspacesRoute
  '/platform/operations': typeof AppPlatformOperationsRoute
  '/platform/releases': typeof AppPlatformReleasesRoute
  '/platform/support': typeof AppPlatformSupportRoute
  '/w/$ws': typeof AppWWsRouteWithChildren
  '/billing': typeof AppBillingIndexRoute
  '/help': typeof AppHelpIndexRoute
  '/platform': typeof AppPlatformIndexRoute
  '/billing/invoices/$invoiceId': typeof AppBillingInvoicesInvoiceIdRoute
  '/connect/sources/$sourceId': typeof AppConnectSourcesSourceIdRoute
  '/govern/privacy/$caseId': typeof AppGovernPrivacyCaseIdRoute
  '/platform/tenants/$tenantId': typeof AppPlatformTenantsTenantIdRoute
  '/w/$ws/access': typeof AppWWsAccessRoute
  '/w/$ws/agents': typeof AppWWsAgentsRoute
  '/w/$ws/approvals': typeof AppWWsApprovalsRoute
  '/w/$ws/branches': typeof AppWWsBranchesRoute
  '/w/$ws/compaction': typeof AppWWsCompactionRoute
  '/w/$ws/company-brain': typeof AppWWsCompanyBrainRoute
  '/w/$ws/context': typeof AppWWsContextRoute
  '/w/$ws/contracts': typeof AppWWsContractsRoute
  '/w/$ws/experiments': typeof AppWWsExperimentsRoute
  '/w/$ws/getting-started': typeof AppWWsGettingStartedRoute
  '/w/$ws/goals': typeof AppWWsGoalsRoute
  '/w/$ws/knowledge': typeof AppWWsKnowledgeRoute
  '/w/$ws/learning': typeof AppWWsLearningRoute
  '/w/$ws/manifests': typeof AppWWsManifestsRoute
  '/w/$ws/memories': typeof AppWWsMemoriesRoute
  '/w/$ws/namespaces': typeof AppWWsNamespacesRoute
  '/w/$ws/overview': typeof AppWWsOverviewRoute
  '/w/$ws/people': typeof AppWWsPeopleRoute
  '/w/$ws/projections': typeof AppWWsProjectionsRoute
  '/w/$ws/provenance': typeof AppWWsProvenanceRoute
  '/w/$ws/replay': typeof AppWWsReplayRoute
  '/w/$ws/review': typeof AppWWsReviewRoute
  '/w/$ws/root-cause': typeof AppWWsRootCauseRoute
  '/w/$ws/runtime': typeof AppWWsRuntimeRoute
  '/w/$ws/sessions': typeof AppWWsSessionsRoute
  '/w/$ws/settings': typeof AppWWsSettingsRoute
  '/w/$ws/setup': typeof AppWWsSetupRoute
  '/w/$ws/simulations': typeof AppWWsSimulationsRoute
  '/w/$ws/skills': typeof AppWWsSkillsRoute
  '/w/$ws/traces': typeof AppWWsTracesRoute
  '/w/$ws/branches/$branchId': typeof AppWWsBranchesBranchIdRoute
  '/w/$ws/contracts/$contractId': typeof AppWWsContractsContractIdRoute
  '/w/$ws/learning/$changeId': typeof AppWWsLearningChangeIdRoute
  '/w/$ws/memories/$memoryId': typeof AppWWsMemoriesMemoryIdRoute
  '/w/$ws/traces/$traceId': typeof AppWWsTracesTraceIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/_public': typeof PublicRouteWithChildren
  '/_public/accept-invite': typeof PublicAcceptInviteRoute
  '/_public/choose-org': typeof PublicChooseOrgRoute
  '/_public/create-org': typeof PublicCreateOrgRoute
  '/_public/forgot-password': typeof PublicForgotPasswordRoute
  '/_public/legal': typeof PublicLegalRoute
  '/_public/login': typeof PublicLoginRoute
  '/_public/maintenance': typeof PublicMaintenanceRoute
  '/_public/mfa': typeof PublicMfaRoute
  '/_public/reset-password': typeof PublicResetPasswordRoute
  '/_public/session-expired': typeof PublicSessionExpiredRoute
  '/_public/signup': typeof PublicSignupRoute
  '/_public/sso': typeof PublicSsoRoute
  '/_public/status': typeof PublicStatusRoute
  '/_public/verify-email': typeof PublicVerifyEmailRoute
  '/_app/': typeof AppIndexRoute
  '/_app/billing/cancel': typeof AppBillingCancelRoute
  '/_app/billing/checkout': typeof AppBillingCheckoutRoute
  '/_app/billing/credits': typeof AppBillingCreditsRoute
  '/_app/billing/details': typeof AppBillingDetailsRoute
  '/_app/billing/invoices': typeof AppBillingInvoicesRoute
  '/_app/billing/payment-methods': typeof AppBillingPaymentMethodsRoute
  '/_app/billing/plans': typeof AppBillingPlansRoute
  '/_app/connect/agent': typeof AppConnectAgentRoute
  '/_app/connect/api-gateway': typeof AppConnectApiGatewayRoute
  '/_app/connect/import': typeof AppConnectImportRoute
  '/_app/connect/ingestion': typeof AppConnectIngestionRoute
  '/_app/connect/integrations': typeof AppConnectIntegrationsRoute
  '/_app/connect/mcp': typeof AppConnectMcpRoute
  '/_app/connect/models': typeof AppConnectModelsRoute
  '/_app/connect/routing': typeof AppConnectRoutingRoute
  '/_app/connect/sources': typeof AppConnectSourcesRoute
  '/_app/connect/storage': typeof AppConnectStorageRoute
  '/_app/connect/webhooks': typeof AppConnectWebhooksRoute
  '/_app/develop/docs': typeof AppDevelopDocsRoute
  '/_app/develop/keys': typeof AppDevelopKeysRoute
  '/_app/develop/playground': typeof AppDevelopPlaygroundRoute
  '/_app/govern/audit': typeof AppGovernAuditRoute
  '/_app/govern/deployments': typeof AppGovernDeploymentsRoute
  '/_app/govern/policies': typeof AppGovernPoliciesRoute
  '/_app/govern/privacy': typeof AppGovernPrivacyRoute
  '/_app/govern/residency': typeof AppGovernResidencyRoute
  '/_app/help/contact': typeof AppHelpContactRoute
  '/_app/help/status': typeof AppHelpStatusRoute
  '/_app/help/whats-new': typeof AppHelpWhatsNewRoute
  '/_app/me/access': typeof AppMeAccessRoute
  '/_app/me/data': typeof AppMeDataRoute
  '/_app/me/memory': typeof AppMeMemoryRoute
  '/_app/me/notification-preferences': typeof AppMeNotificationPreferencesRoute
  '/_app/me/notifications': typeof AppMeNotificationsRoute
  '/_app/me/profile': typeof AppMeProfileRoute
  '/_app/me/security': typeof AppMeSecurityRoute
  '/_app/org/budgets': typeof AppOrgBudgetsRoute
  '/_app/org/members': typeof AppOrgMembersRoute
  '/_app/org/products': typeof AppOrgProductsRoute
  '/_app/org/roles': typeof AppOrgRolesRoute
  '/_app/org/settings': typeof AppOrgSettingsRoute
  '/_app/org/sso': typeof AppOrgSsoRoute
  '/_app/org/support-access': typeof AppOrgSupportAccessRoute
  '/_app/org/usage': typeof AppOrgUsageRoute
  '/_app/org/workspaces': typeof AppOrgWorkspacesRoute
  '/_app/platform/operations': typeof AppPlatformOperationsRoute
  '/_app/platform/releases': typeof AppPlatformReleasesRoute
  '/_app/platform/support': typeof AppPlatformSupportRoute
  '/_app/w/$ws': typeof AppWWsRouteWithChildren
  '/_app/billing/': typeof AppBillingIndexRoute
  '/_app/help/': typeof AppHelpIndexRoute
  '/_app/platform/': typeof AppPlatformIndexRoute
  '/_app/billing/invoices_/$invoiceId': typeof AppBillingInvoicesInvoiceIdRoute
  '/_app/connect/sources_/$sourceId': typeof AppConnectSourcesSourceIdRoute
  '/_app/govern/privacy_/$caseId': typeof AppGovernPrivacyCaseIdRoute
  '/_app/platform/tenants/$tenantId': typeof AppPlatformTenantsTenantIdRoute
  '/_app/w/$ws/access': typeof AppWWsAccessRoute
  '/_app/w/$ws/agents': typeof AppWWsAgentsRoute
  '/_app/w/$ws/approvals': typeof AppWWsApprovalsRoute
  '/_app/w/$ws/branches': typeof AppWWsBranchesRoute
  '/_app/w/$ws/compaction': typeof AppWWsCompactionRoute
  '/_app/w/$ws/company-brain': typeof AppWWsCompanyBrainRoute
  '/_app/w/$ws/context': typeof AppWWsContextRoute
  '/_app/w/$ws/contracts': typeof AppWWsContractsRoute
  '/_app/w/$ws/experiments': typeof AppWWsExperimentsRoute
  '/_app/w/$ws/getting-started': typeof AppWWsGettingStartedRoute
  '/_app/w/$ws/goals': typeof AppWWsGoalsRoute
  '/_app/w/$ws/knowledge': typeof AppWWsKnowledgeRoute
  '/_app/w/$ws/learning': typeof AppWWsLearningRoute
  '/_app/w/$ws/manifests': typeof AppWWsManifestsRoute
  '/_app/w/$ws/memories': typeof AppWWsMemoriesRoute
  '/_app/w/$ws/namespaces': typeof AppWWsNamespacesRoute
  '/_app/w/$ws/overview': typeof AppWWsOverviewRoute
  '/_app/w/$ws/people': typeof AppWWsPeopleRoute
  '/_app/w/$ws/projections': typeof AppWWsProjectionsRoute
  '/_app/w/$ws/provenance': typeof AppWWsProvenanceRoute
  '/_app/w/$ws/replay': typeof AppWWsReplayRoute
  '/_app/w/$ws/review': typeof AppWWsReviewRoute
  '/_app/w/$ws/root-cause': typeof AppWWsRootCauseRoute
  '/_app/w/$ws/runtime': typeof AppWWsRuntimeRoute
  '/_app/w/$ws/sessions': typeof AppWWsSessionsRoute
  '/_app/w/$ws/settings': typeof AppWWsSettingsRoute
  '/_app/w/$ws/setup': typeof AppWWsSetupRoute
  '/_app/w/$ws/simulations': typeof AppWWsSimulationsRoute
  '/_app/w/$ws/skills': typeof AppWWsSkillsRoute
  '/_app/w/$ws/traces': typeof AppWWsTracesRoute
  '/_app/w/$ws/branches_/$branchId': typeof AppWWsBranchesBranchIdRoute
  '/_app/w/$ws/contracts_/$contractId': typeof AppWWsContractsContractIdRoute
  '/_app/w/$ws/learning_/$changeId': typeof AppWWsLearningChangeIdRoute
  '/_app/w/$ws/memories_/$memoryId': typeof AppWWsMemoriesMemoryIdRoute
  '/_app/w/$ws/traces_/$traceId': typeof AppWWsTracesTraceIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/accept-invite'
    | '/choose-org'
    | '/create-org'
    | '/forgot-password'
    | '/legal'
    | '/login'
    | '/maintenance'
    | '/mfa'
    | '/reset-password'
    | '/session-expired'
    | '/signup'
    | '/sso'
    | '/status'
    | '/verify-email'
    | '/billing/cancel'
    | '/billing/checkout'
    | '/billing/credits'
    | '/billing/details'
    | '/billing/invoices'
    | '/billing/payment-methods'
    | '/billing/plans'
    | '/connect/agent'
    | '/connect/api-gateway'
    | '/connect/import'
    | '/connect/ingestion'
    | '/connect/integrations'
    | '/connect/mcp'
    | '/connect/models'
    | '/connect/routing'
    | '/connect/sources'
    | '/connect/storage'
    | '/connect/webhooks'
    | '/develop/docs'
    | '/develop/keys'
    | '/develop/playground'
    | '/govern/audit'
    | '/govern/deployments'
    | '/govern/policies'
    | '/govern/privacy'
    | '/govern/residency'
    | '/help/contact'
    | '/help/status'
    | '/help/whats-new'
    | '/me/access'
    | '/me/data'
    | '/me/memory'
    | '/me/notification-preferences'
    | '/me/notifications'
    | '/me/profile'
    | '/me/security'
    | '/org/budgets'
    | '/org/members'
    | '/org/products'
    | '/org/roles'
    | '/org/settings'
    | '/org/sso'
    | '/org/support-access'
    | '/org/usage'
    | '/org/workspaces'
    | '/platform/operations'
    | '/platform/releases'
    | '/platform/support'
    | '/w/$ws'
    | '/billing/'
    | '/help/'
    | '/platform/'
    | '/billing/invoices/$invoiceId'
    | '/connect/sources/$sourceId'
    | '/govern/privacy/$caseId'
    | '/platform/tenants/$tenantId'
    | '/w/$ws/access'
    | '/w/$ws/agents'
    | '/w/$ws/approvals'
    | '/w/$ws/branches'
    | '/w/$ws/compaction'
    | '/w/$ws/company-brain'
    | '/w/$ws/context'
    | '/w/$ws/contracts'
    | '/w/$ws/experiments'
    | '/w/$ws/getting-started'
    | '/w/$ws/goals'
    | '/w/$ws/knowledge'
    | '/w/$ws/learning'
    | '/w/$ws/manifests'
    | '/w/$ws/memories'
    | '/w/$ws/namespaces'
    | '/w/$ws/overview'
    | '/w/$ws/people'
    | '/w/$ws/projections'
    | '/w/$ws/provenance'
    | '/w/$ws/replay'
    | '/w/$ws/review'
    | '/w/$ws/root-cause'
    | '/w/$ws/runtime'
    | '/w/$ws/sessions'
    | '/w/$ws/settings'
    | '/w/$ws/setup'
    | '/w/$ws/simulations'
    | '/w/$ws/skills'
    | '/w/$ws/traces'
    | '/w/$ws/branches/$branchId'
    | '/w/$ws/contracts/$contractId'
    | '/w/$ws/learning/$changeId'
    | '/w/$ws/memories/$memoryId'
    | '/w/$ws/traces/$traceId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/accept-invite'
    | '/choose-org'
    | '/create-org'
    | '/forgot-password'
    | '/legal'
    | '/login'
    | '/maintenance'
    | '/mfa'
    | '/reset-password'
    | '/session-expired'
    | '/signup'
    | '/sso'
    | '/status'
    | '/verify-email'
    | '/billing/cancel'
    | '/billing/checkout'
    | '/billing/credits'
    | '/billing/details'
    | '/billing/invoices'
    | '/billing/payment-methods'
    | '/billing/plans'
    | '/connect/agent'
    | '/connect/api-gateway'
    | '/connect/import'
    | '/connect/ingestion'
    | '/connect/integrations'
    | '/connect/mcp'
    | '/connect/models'
    | '/connect/routing'
    | '/connect/sources'
    | '/connect/storage'
    | '/connect/webhooks'
    | '/develop/docs'
    | '/develop/keys'
    | '/develop/playground'
    | '/govern/audit'
    | '/govern/deployments'
    | '/govern/policies'
    | '/govern/privacy'
    | '/govern/residency'
    | '/help/contact'
    | '/help/status'
    | '/help/whats-new'
    | '/me/access'
    | '/me/data'
    | '/me/memory'
    | '/me/notification-preferences'
    | '/me/notifications'
    | '/me/profile'
    | '/me/security'
    | '/org/budgets'
    | '/org/members'
    | '/org/products'
    | '/org/roles'
    | '/org/settings'
    | '/org/sso'
    | '/org/support-access'
    | '/org/usage'
    | '/org/workspaces'
    | '/platform/operations'
    | '/platform/releases'
    | '/platform/support'
    | '/w/$ws'
    | '/billing'
    | '/help'
    | '/platform'
    | '/billing/invoices/$invoiceId'
    | '/connect/sources/$sourceId'
    | '/govern/privacy/$caseId'
    | '/platform/tenants/$tenantId'
    | '/w/$ws/access'
    | '/w/$ws/agents'
    | '/w/$ws/approvals'
    | '/w/$ws/branches'
    | '/w/$ws/compaction'
    | '/w/$ws/company-brain'
    | '/w/$ws/context'
    | '/w/$ws/contracts'
    | '/w/$ws/experiments'
    | '/w/$ws/getting-started'
    | '/w/$ws/goals'
    | '/w/$ws/knowledge'
    | '/w/$ws/learning'
    | '/w/$ws/manifests'
    | '/w/$ws/memories'
    | '/w/$ws/namespaces'
    | '/w/$ws/overview'
    | '/w/$ws/people'
    | '/w/$ws/projections'
    | '/w/$ws/provenance'
    | '/w/$ws/replay'
    | '/w/$ws/review'
    | '/w/$ws/root-cause'
    | '/w/$ws/runtime'
    | '/w/$ws/sessions'
    | '/w/$ws/settings'
    | '/w/$ws/setup'
    | '/w/$ws/simulations'
    | '/w/$ws/skills'
    | '/w/$ws/traces'
    | '/w/$ws/branches/$branchId'
    | '/w/$ws/contracts/$contractId'
    | '/w/$ws/learning/$changeId'
    | '/w/$ws/memories/$memoryId'
    | '/w/$ws/traces/$traceId'
  id:
    | '__root__'
    | '/_app'
    | '/_public'
    | '/_public/accept-invite'
    | '/_public/choose-org'
    | '/_public/create-org'
    | '/_public/forgot-password'
    | '/_public/legal'
    | '/_public/login'
    | '/_public/maintenance'
    | '/_public/mfa'
    | '/_public/reset-password'
    | '/_public/session-expired'
    | '/_public/signup'
    | '/_public/sso'
    | '/_public/status'
    | '/_public/verify-email'
    | '/_app/'
    | '/_app/billing/cancel'
    | '/_app/billing/checkout'
    | '/_app/billing/credits'
    | '/_app/billing/details'
    | '/_app/billing/invoices'
    | '/_app/billing/payment-methods'
    | '/_app/billing/plans'
    | '/_app/connect/agent'
    | '/_app/connect/api-gateway'
    | '/_app/connect/import'
    | '/_app/connect/ingestion'
    | '/_app/connect/integrations'
    | '/_app/connect/mcp'
    | '/_app/connect/models'
    | '/_app/connect/routing'
    | '/_app/connect/sources'
    | '/_app/connect/storage'
    | '/_app/connect/webhooks'
    | '/_app/develop/docs'
    | '/_app/develop/keys'
    | '/_app/develop/playground'
    | '/_app/govern/audit'
    | '/_app/govern/deployments'
    | '/_app/govern/policies'
    | '/_app/govern/privacy'
    | '/_app/govern/residency'
    | '/_app/help/contact'
    | '/_app/help/status'
    | '/_app/help/whats-new'
    | '/_app/me/access'
    | '/_app/me/data'
    | '/_app/me/memory'
    | '/_app/me/notification-preferences'
    | '/_app/me/notifications'
    | '/_app/me/profile'
    | '/_app/me/security'
    | '/_app/org/budgets'
    | '/_app/org/members'
    | '/_app/org/products'
    | '/_app/org/roles'
    | '/_app/org/settings'
    | '/_app/org/sso'
    | '/_app/org/support-access'
    | '/_app/org/usage'
    | '/_app/org/workspaces'
    | '/_app/platform/operations'
    | '/_app/platform/releases'
    | '/_app/platform/support'
    | '/_app/w/$ws'
    | '/_app/billing/'
    | '/_app/help/'
    | '/_app/platform/'
    | '/_app/billing/invoices_/$invoiceId'
    | '/_app/connect/sources_/$sourceId'
    | '/_app/govern/privacy_/$caseId'
    | '/_app/platform/tenants/$tenantId'
    | '/_app/w/$ws/access'
    | '/_app/w/$ws/agents'
    | '/_app/w/$ws/approvals'
    | '/_app/w/$ws/branches'
    | '/_app/w/$ws/compaction'
    | '/_app/w/$ws/company-brain'
    | '/_app/w/$ws/context'
    | '/_app/w/$ws/contracts'
    | '/_app/w/$ws/experiments'
    | '/_app/w/$ws/getting-started'
    | '/_app/w/$ws/goals'
    | '/_app/w/$ws/knowledge'
    | '/_app/w/$ws/learning'
    | '/_app/w/$ws/manifests'
    | '/_app/w/$ws/memories'
    | '/_app/w/$ws/namespaces'
    | '/_app/w/$ws/overview'
    | '/_app/w/$ws/people'
    | '/_app/w/$ws/projections'
    | '/_app/w/$ws/provenance'
    | '/_app/w/$ws/replay'
    | '/_app/w/$ws/review'
    | '/_app/w/$ws/root-cause'
    | '/_app/w/$ws/runtime'
    | '/_app/w/$ws/sessions'
    | '/_app/w/$ws/settings'
    | '/_app/w/$ws/setup'
    | '/_app/w/$ws/simulations'
    | '/_app/w/$ws/skills'
    | '/_app/w/$ws/traces'
    | '/_app/w/$ws/branches_/$branchId'
    | '/_app/w/$ws/contracts_/$contractId'
    | '/_app/w/$ws/learning_/$changeId'
    | '/_app/w/$ws/memories_/$memoryId'
    | '/_app/w/$ws/traces_/$traceId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  PublicRoute: typeof PublicRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PublicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_public/accept-invite': {
      id: '/_public/accept-invite'
      path: '/accept-invite'
      fullPath: '/accept-invite'
      preLoaderRoute: typeof PublicAcceptInviteRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/choose-org': {
      id: '/_public/choose-org'
      path: '/choose-org'
      fullPath: '/choose-org'
      preLoaderRoute: typeof PublicChooseOrgRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/create-org': {
      id: '/_public/create-org'
      path: '/create-org'
      fullPath: '/create-org'
      preLoaderRoute: typeof PublicCreateOrgRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/forgot-password': {
      id: '/_public/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof PublicForgotPasswordRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/legal': {
      id: '/_public/legal'
      path: '/legal'
      fullPath: '/legal'
      preLoaderRoute: typeof PublicLegalRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/login': {
      id: '/_public/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof PublicLoginRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/maintenance': {
      id: '/_public/maintenance'
      path: '/maintenance'
      fullPath: '/maintenance'
      preLoaderRoute: typeof PublicMaintenanceRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/mfa': {
      id: '/_public/mfa'
      path: '/mfa'
      fullPath: '/mfa'
      preLoaderRoute: typeof PublicMfaRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/reset-password': {
      id: '/_public/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof PublicResetPasswordRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/session-expired': {
      id: '/_public/session-expired'
      path: '/session-expired'
      fullPath: '/session-expired'
      preLoaderRoute: typeof PublicSessionExpiredRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/signup': {
      id: '/_public/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof PublicSignupRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/sso': {
      id: '/_public/sso'
      path: '/sso'
      fullPath: '/sso'
      preLoaderRoute: typeof PublicSsoRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/status': {
      id: '/_public/status'
      path: '/status'
      fullPath: '/status'
      preLoaderRoute: typeof PublicStatusRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/verify-email': {
      id: '/_public/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof PublicVerifyEmailRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_app/billing/': {
      id: '/_app/billing/'
      path: '/billing'
      fullPath: '/billing/'
      preLoaderRoute: typeof AppBillingIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/billing/cancel': {
      id: '/_app/billing/cancel'
      path: '/billing/cancel'
      fullPath: '/billing/cancel'
      preLoaderRoute: typeof AppBillingCancelRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/billing/checkout': {
      id: '/_app/billing/checkout'
      path: '/billing/checkout'
      fullPath: '/billing/checkout'
      preLoaderRoute: typeof AppBillingCheckoutRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/billing/credits': {
      id: '/_app/billing/credits'
      path: '/billing/credits'
      fullPath: '/billing/credits'
      preLoaderRoute: typeof AppBillingCreditsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/billing/details': {
      id: '/_app/billing/details'
      path: '/billing/details'
      fullPath: '/billing/details'
      preLoaderRoute: typeof AppBillingDetailsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/billing/invoices': {
      id: '/_app/billing/invoices'
      path: '/billing/invoices'
      fullPath: '/billing/invoices'
      preLoaderRoute: typeof AppBillingInvoicesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/billing/payment-methods': {
      id: '/_app/billing/payment-methods'
      path: '/billing/payment-methods'
      fullPath: '/billing/payment-methods'
      preLoaderRoute: typeof AppBillingPaymentMethodsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/billing/plans': {
      id: '/_app/billing/plans'
      path: '/billing/plans'
      fullPath: '/billing/plans'
      preLoaderRoute: typeof AppBillingPlansRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/connect/agent': {
      id: '/_app/connect/agent'
      path: '/connect/agent'
      fullPath: '/connect/agent'
      preLoaderRoute: typeof AppConnectAgentRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/connect/api-gateway': {
      id: '/_app/connect/api-gateway'
      path: '/connect/api-gateway'
      fullPath: '/connect/api-gateway'
      preLoaderRoute: typeof AppConnectApiGatewayRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/connect/import': {
      id: '/_app/connect/import'
      path: '/connect/import'
      fullPath: '/connect/import'
      preLoaderRoute: typeof AppConnectImportRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/connect/ingestion': {
      id: '/_app/connect/ingestion'
      path: '/connect/ingestion'
      fullPath: '/connect/ingestion'
      preLoaderRoute: typeof AppConnectIngestionRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/connect/integrations': {
      id: '/_app/connect/integrations'
      path: '/connect/integrations'
      fullPath: '/connect/integrations'
      preLoaderRoute: typeof AppConnectIntegrationsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/connect/mcp': {
      id: '/_app/connect/mcp'
      path: '/connect/mcp'
      fullPath: '/connect/mcp'
      preLoaderRoute: typeof AppConnectMcpRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/connect/models': {
      id: '/_app/connect/models'
      path: '/connect/models'
      fullPath: '/connect/models'
      preLoaderRoute: typeof AppConnectModelsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/connect/routing': {
      id: '/_app/connect/routing'
      path: '/connect/routing'
      fullPath: '/connect/routing'
      preLoaderRoute: typeof AppConnectRoutingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/connect/sources': {
      id: '/_app/connect/sources'
      path: '/connect/sources'
      fullPath: '/connect/sources'
      preLoaderRoute: typeof AppConnectSourcesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/connect/storage': {
      id: '/_app/connect/storage'
      path: '/connect/storage'
      fullPath: '/connect/storage'
      preLoaderRoute: typeof AppConnectStorageRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/connect/webhooks': {
      id: '/_app/connect/webhooks'
      path: '/connect/webhooks'
      fullPath: '/connect/webhooks'
      preLoaderRoute: typeof AppConnectWebhooksRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/develop/docs': {
      id: '/_app/develop/docs'
      path: '/develop/docs'
      fullPath: '/develop/docs'
      preLoaderRoute: typeof AppDevelopDocsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/develop/keys': {
      id: '/_app/develop/keys'
      path: '/develop/keys'
      fullPath: '/develop/keys'
      preLoaderRoute: typeof AppDevelopKeysRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/develop/playground': {
      id: '/_app/develop/playground'
      path: '/develop/playground'
      fullPath: '/develop/playground'
      preLoaderRoute: typeof AppDevelopPlaygroundRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/govern/audit': {
      id: '/_app/govern/audit'
      path: '/govern/audit'
      fullPath: '/govern/audit'
      preLoaderRoute: typeof AppGovernAuditRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/govern/deployments': {
      id: '/_app/govern/deployments'
      path: '/govern/deployments'
      fullPath: '/govern/deployments'
      preLoaderRoute: typeof AppGovernDeploymentsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/govern/policies': {
      id: '/_app/govern/policies'
      path: '/govern/policies'
      fullPath: '/govern/policies'
      preLoaderRoute: typeof AppGovernPoliciesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/govern/privacy': {
      id: '/_app/govern/privacy'
      path: '/govern/privacy'
      fullPath: '/govern/privacy'
      preLoaderRoute: typeof AppGovernPrivacyRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/govern/residency': {
      id: '/_app/govern/residency'
      path: '/govern/residency'
      fullPath: '/govern/residency'
      preLoaderRoute: typeof AppGovernResidencyRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/help/': {
      id: '/_app/help/'
      path: '/help'
      fullPath: '/help/'
      preLoaderRoute: typeof AppHelpIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/help/contact': {
      id: '/_app/help/contact'
      path: '/help/contact'
      fullPath: '/help/contact'
      preLoaderRoute: typeof AppHelpContactRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/help/status': {
      id: '/_app/help/status'
      path: '/help/status'
      fullPath: '/help/status'
      preLoaderRoute: typeof AppHelpStatusRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/help/whats-new': {
      id: '/_app/help/whats-new'
      path: '/help/whats-new'
      fullPath: '/help/whats-new'
      preLoaderRoute: typeof AppHelpWhatsNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/me/access': {
      id: '/_app/me/access'
      path: '/me/access'
      fullPath: '/me/access'
      preLoaderRoute: typeof AppMeAccessRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/me/data': {
      id: '/_app/me/data'
      path: '/me/data'
      fullPath: '/me/data'
      preLoaderRoute: typeof AppMeDataRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/me/memory': {
      id: '/_app/me/memory'
      path: '/me/memory'
      fullPath: '/me/memory'
      preLoaderRoute: typeof AppMeMemoryRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/me/notification-preferences': {
      id: '/_app/me/notification-preferences'
      path: '/me/notification-preferences'
      fullPath: '/me/notification-preferences'
      preLoaderRoute: typeof AppMeNotificationPreferencesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/me/notifications': {
      id: '/_app/me/notifications'
      path: '/me/notifications'
      fullPath: '/me/notifications'
      preLoaderRoute: typeof AppMeNotificationsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/me/profile': {
      id: '/_app/me/profile'
      path: '/me/profile'
      fullPath: '/me/profile'
      preLoaderRoute: typeof AppMeProfileRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/me/security': {
      id: '/_app/me/security'
      path: '/me/security'
      fullPath: '/me/security'
      preLoaderRoute: typeof AppMeSecurityRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/org/budgets': {
      id: '/_app/org/budgets'
      path: '/org/budgets'
      fullPath: '/org/budgets'
      preLoaderRoute: typeof AppOrgBudgetsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/org/members': {
      id: '/_app/org/members'
      path: '/org/members'
      fullPath: '/org/members'
      preLoaderRoute: typeof AppOrgMembersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/org/products': {
      id: '/_app/org/products'
      path: '/org/products'
      fullPath: '/org/products'
      preLoaderRoute: typeof AppOrgProductsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/org/roles': {
      id: '/_app/org/roles'
      path: '/org/roles'
      fullPath: '/org/roles'
      preLoaderRoute: typeof AppOrgRolesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/org/settings': {
      id: '/_app/org/settings'
      path: '/org/settings'
      fullPath: '/org/settings'
      preLoaderRoute: typeof AppOrgSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/org/sso': {
      id: '/_app/org/sso'
      path: '/org/sso'
      fullPath: '/org/sso'
      preLoaderRoute: typeof AppOrgSsoRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/org/support-access': {
      id: '/_app/org/support-access'
      path: '/org/support-access'
      fullPath: '/org/support-access'
      preLoaderRoute: typeof AppOrgSupportAccessRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/org/usage': {
      id: '/_app/org/usage'
      path: '/org/usage'
      fullPath: '/org/usage'
      preLoaderRoute: typeof AppOrgUsageRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/org/workspaces': {
      id: '/_app/org/workspaces'
      path: '/org/workspaces'
      fullPath: '/org/workspaces'
      preLoaderRoute: typeof AppOrgWorkspacesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/platform/': {
      id: '/_app/platform/'
      path: '/platform'
      fullPath: '/platform/'
      preLoaderRoute: typeof AppPlatformIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/platform/operations': {
      id: '/_app/platform/operations'
      path: '/platform/operations'
      fullPath: '/platform/operations'
      preLoaderRoute: typeof AppPlatformOperationsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/platform/releases': {
      id: '/_app/platform/releases'
      path: '/platform/releases'
      fullPath: '/platform/releases'
      preLoaderRoute: typeof AppPlatformReleasesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/platform/support': {
      id: '/_app/platform/support'
      path: '/platform/support'
      fullPath: '/platform/support'
      preLoaderRoute: typeof AppPlatformSupportRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/w/$ws': {
      id: '/_app/w/$ws'
      path: '/w/$ws'
      fullPath: '/w/$ws'
      preLoaderRoute: typeof AppWWsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/billing/invoices_/$invoiceId': {
      id: '/_app/billing/invoices_/$invoiceId'
      path: '/billing/invoices/$invoiceId'
      fullPath: '/billing/invoices/$invoiceId'
      preLoaderRoute: typeof AppBillingInvoicesInvoiceIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/connect/sources_/$sourceId': {
      id: '/_app/connect/sources_/$sourceId'
      path: '/connect/sources/$sourceId'
      fullPath: '/connect/sources/$sourceId'
      preLoaderRoute: typeof AppConnectSourcesSourceIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/govern/privacy_/$caseId': {
      id: '/_app/govern/privacy_/$caseId'
      path: '/govern/privacy/$caseId'
      fullPath: '/govern/privacy/$caseId'
      preLoaderRoute: typeof AppGovernPrivacyCaseIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/platform/tenants/$tenantId': {
      id: '/_app/platform/tenants/$tenantId'
      path: '/platform/tenants/$tenantId'
      fullPath: '/platform/tenants/$tenantId'
      preLoaderRoute: typeof AppPlatformTenantsTenantIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/w/$ws/access': {
      id: '/_app/w/$ws/access'
      path: '/access'
      fullPath: '/w/$ws/access'
      preLoaderRoute: typeof AppWWsAccessRouteImport
      parentRoute: typeof AppWWsRoute
    }
    '/_app/w/$ws/agents': {
      id: '/_app/w/$ws/agents'
      path: '/agents'
      fullPath: '/w/$ws/agents'
      preLoaderRoute: typeof AppWWsAgentsRouteImport
      parentRoute: typeof AppWWsRoute
    }
    '/_app/w/$ws/approvals': {
      id: '/_app/w/$ws/approvals'
      path: '/approvals'
      fullPath: '/w/$ws/approvals'
      preLoaderRoute: typeof AppWWsApprovalsRouteImport
      parentRoute: typeof AppWWsRoute
    }
    '/_app/w/$ws/branches': {
      id: '/_app/w/$ws/branches'
      path: '/branches'
      fullPath: '/w/$ws/branches'
      preLoaderRoute: typeof AppWWsBranchesRouteImport
      parentRoute: typeof AppWWsRoute
    }
    '/_app/w/$ws/compaction': {
      id: '/_app/w/$ws/compaction'
      path: '/compaction'
      fullPath: '/w/$ws/compaction'
      preLoaderRoute: typeof AppWWsCompactionRouteImport
      parentRoute: typeof AppWWsRoute
    }
    '/_app/w/$ws/company-brain': {
      id: '/_app/w/$ws/company-brain'
      path: '/company-brain'
      fullPath: '/w/$ws/company-brain'
      preLoaderRoute: typeof AppWWsCompanyBrainRouteImport
      parentRoute: typeof AppWWsRoute
    }
    '/_app/w/$ws/context': {
      id: '/_app/w/$ws/context'
      path: '/context'
      fullPath: '/w/$ws/context'
      preLoaderRoute: typeof AppWWsContextRouteImport
      parentRoute: typeof AppWWsRoute
    }
    '/_app/w/$ws/contracts': {
      id: '/_app/w/$ws/contracts'
      path: '/contracts'
      fullPath: '/w/$ws/contracts'
      preLoaderRoute: typeof AppWWsContractsRouteImport
      parentRoute: typeof AppWWsRoute
    }
    '/_app/w/$ws/experiments': {
      id: '/_app/w/$ws/experiments'
      path: '/experiments'
      fullPath: '/w/$ws/experiments'
      preLoaderRoute: typeof AppWWsExperimentsRouteImport
      parentRoute: typeof AppWWsRoute
    }
    '/_app/w/$ws/getting-started': {
      id: '/_app/w/$ws/getting-started'
      path: '/getting-started'
      fullPath: '/w/$ws/getting-started'
      preLoaderRoute: typeof AppWWsGettingStartedRouteImport
      parentRoute: typeof AppWWsRoute
    }
    '/_app/w/$ws/goals': {
      id: '/_app/w/$ws/goals'
      path: '/goals'
      fullPath: '/w/$ws/goals'
      preLoaderRoute: typeof AppWWsGoalsRouteImport
      parentRoute: typeof AppWWsRoute
    }
    '/_app/w/$ws/knowledge': {
      id: '/_app/w/$ws/knowledge'
      path: '/knowledge'
      fullPath: '/w/$ws/knowledge'
      preLoaderRoute: typeof AppWWsKnowledgeRouteImport
      parentRoute: typeof AppWWsRoute
    }
    '/_app/w/$ws/learning': {
      id: '/_app/w/$ws/learning'
      path: '/learning'
      fullPath: '/w/$ws/learning'
      preLoaderRoute: typeof AppWWsLearningRouteImport
      parentRoute: typeof AppWWsRoute
    }
    '/_app/w/$ws/manifests': {
      id: '/_app/w/$ws/manifests'
      path: '/manifests'
      fullPath: '/w/$ws/manifests'
      preLoaderRoute: typeof AppWWsManifestsRouteImport
      parentRoute: typeof AppWWsRoute
    }
    '/_app/w/$ws/memories': {
      id: '/_app/w/$ws/memories'
      path: '/memories'
      fullPath: '/w/$ws/memories'
      preLoaderRoute: typeof AppWWsMemoriesRouteImport
      parentRoute: typeof AppWWsRoute
    }
    '/_app/w/$ws/namespaces': {
      id: '/_app/w/$ws/namespaces'
      path: '/namespaces'
      fullPath: '/w/$ws/namespaces'
      preLoaderRoute: typeof AppWWsNamespacesRouteImport
      parentRoute: typeof AppWWsRoute
    }
    '/_app/w/$ws/overview': {
      id: '/_app/w/$ws/overview'
      path: '/overview'
      fullPath: '/w/$ws/overview'
      preLoaderRoute: typeof AppWWsOverviewRouteImport
      parentRoute: typeof AppWWsRoute
    }
    '/_app/w/$ws/people': {
      id: '/_app/w/$ws/people'
      path: '/people'
      fullPath: '/w/$ws/people'
      preLoaderRoute: typeof AppWWsPeopleRouteImport
      parentRoute: typeof AppWWsRoute
    }
    '/_app/w/$ws/projections': {
      id: '/_app/w/$ws/projections'
      path: '/projections'
      fullPath: '/w/$ws/projections'
      preLoaderRoute: typeof AppWWsProjectionsRouteImport
      parentRoute: typeof AppWWsRoute
    }
    '/_app/w/$ws/provenance': {
      id: '/_app/w/$ws/provenance'
      path: '/provenance'
      fullPath: '/w/$ws/provenance'
      preLoaderRoute: typeof AppWWsProvenanceRouteImport
      parentRoute: typeof AppWWsRoute
    }
    '/_app/w/$ws/replay': {
      id: '/_app/w/$ws/replay'
      path: '/replay'
      fullPath: '/w/$ws/replay'
      preLoaderRoute: typeof AppWWsReplayRouteImport
      parentRoute: typeof AppWWsRoute
    }
    '/_app/w/$ws/review': {
      id: '/_app/w/$ws/review'
      path: '/review'
      fullPath: '/w/$ws/review'
      preLoaderRoute: typeof AppWWsReviewRouteImport
      parentRoute: typeof AppWWsRoute
    }
    '/_app/w/$ws/root-cause': {
      id: '/_app/w/$ws/root-cause'
      path: '/root-cause'
      fullPath: '/w/$ws/root-cause'
      preLoaderRoute: typeof AppWWsRootCauseRouteImport
      parentRoute: typeof AppWWsRoute
    }
    '/_app/w/$ws/runtime': {
      id: '/_app/w/$ws/runtime'
      path: '/runtime'
      fullPath: '/w/$ws/runtime'
      preLoaderRoute: typeof AppWWsRuntimeRouteImport
      parentRoute: typeof AppWWsRoute
    }
    '/_app/w/$ws/sessions': {
      id: '/_app/w/$ws/sessions'
      path: '/sessions'
      fullPath: '/w/$ws/sessions'
      preLoaderRoute: typeof AppWWsSessionsRouteImport
      parentRoute: typeof AppWWsRoute
    }
    '/_app/w/$ws/settings': {
      id: '/_app/w/$ws/settings'
      path: '/settings'
      fullPath: '/w/$ws/settings'
      preLoaderRoute: typeof AppWWsSettingsRouteImport
      parentRoute: typeof AppWWsRoute
    }
    '/_app/w/$ws/setup': {
      id: '/_app/w/$ws/setup'
      path: '/setup'
      fullPath: '/w/$ws/setup'
      preLoaderRoute: typeof AppWWsSetupRouteImport
      parentRoute: typeof AppWWsRoute
    }
    '/_app/w/$ws/simulations': {
      id: '/_app/w/$ws/simulations'
      path: '/simulations'
      fullPath: '/w/$ws/simulations'
      preLoaderRoute: typeof AppWWsSimulationsRouteImport
      parentRoute: typeof AppWWsRoute
    }
    '/_app/w/$ws/skills': {
      id: '/_app/w/$ws/skills'
      path: '/skills'
      fullPath: '/w/$ws/skills'
      preLoaderRoute: typeof AppWWsSkillsRouteImport
      parentRoute: typeof AppWWsRoute
    }
    '/_app/w/$ws/traces': {
      id: '/_app/w/$ws/traces'
      path: '/traces'
      fullPath: '/w/$ws/traces'
      preLoaderRoute: typeof AppWWsTracesRouteImport
      parentRoute: typeof AppWWsRoute
    }
    '/_app/w/$ws/branches_/$branchId': {
      id: '/_app/w/$ws/branches_/$branchId'
      path: '/branches/$branchId'
      fullPath: '/w/$ws/branches/$branchId'
      preLoaderRoute: typeof AppWWsBranchesBranchIdRouteImport
      parentRoute: typeof AppWWsRoute
    }
    '/_app/w/$ws/contracts_/$contractId': {
      id: '/_app/w/$ws/contracts_/$contractId'
      path: '/contracts/$contractId'
      fullPath: '/w/$ws/contracts/$contractId'
      preLoaderRoute: typeof AppWWsContractsContractIdRouteImport
      parentRoute: typeof AppWWsRoute
    }
    '/_app/w/$ws/learning_/$changeId': {
      id: '/_app/w/$ws/learning_/$changeId'
      path: '/learning/$changeId'
      fullPath: '/w/$ws/learning/$changeId'
      preLoaderRoute: typeof AppWWsLearningChangeIdRouteImport
      parentRoute: typeof AppWWsRoute
    }
    '/_app/w/$ws/memories_/$memoryId': {
      id: '/_app/w/$ws/memories_/$memoryId'
      path: '/memories/$memoryId'
      fullPath: '/w/$ws/memories/$memoryId'
      preLoaderRoute: typeof AppWWsMemoriesMemoryIdRouteImport
      parentRoute: typeof AppWWsRoute
    }
    '/_app/w/$ws/traces_/$traceId': {
      id: '/_app/w/$ws/traces_/$traceId'
      path: '/traces/$traceId'
      fullPath: '/w/$ws/traces/$traceId'
      preLoaderRoute: typeof AppWWsTracesTraceIdRouteImport
      parentRoute: typeof AppWWsRoute
    }
  }
}

interface AppWWsRouteChildren {
  AppWWsAccessRoute: typeof AppWWsAccessRoute
  AppWWsAgentsRoute: typeof AppWWsAgentsRoute
  AppWWsApprovalsRoute: typeof AppWWsApprovalsRoute
  AppWWsBranchesRoute: typeof AppWWsBranchesRoute
  AppWWsCompactionRoute: typeof AppWWsCompactionRoute
  AppWWsCompanyBrainRoute: typeof AppWWsCompanyBrainRoute
  AppWWsContextRoute: typeof AppWWsContextRoute
  AppWWsContractsRoute: typeof AppWWsContractsRoute
  AppWWsExperimentsRoute: typeof AppWWsExperimentsRoute
  AppWWsGettingStartedRoute: typeof AppWWsGettingStartedRoute
  AppWWsGoalsRoute: typeof AppWWsGoalsRoute
  AppWWsKnowledgeRoute: typeof AppWWsKnowledgeRoute
  AppWWsLearningRoute: typeof AppWWsLearningRoute
  AppWWsManifestsRoute: typeof AppWWsManifestsRoute
  AppWWsMemoriesRoute: typeof AppWWsMemoriesRoute
  AppWWsNamespacesRoute: typeof AppWWsNamespacesRoute
  AppWWsOverviewRoute: typeof AppWWsOverviewRoute
  AppWWsPeopleRoute: typeof AppWWsPeopleRoute
  AppWWsProjectionsRoute: typeof AppWWsProjectionsRoute
  AppWWsProvenanceRoute: typeof AppWWsProvenanceRoute
  AppWWsReplayRoute: typeof AppWWsReplayRoute
  AppWWsReviewRoute: typeof AppWWsReviewRoute
  AppWWsRootCauseRoute: typeof AppWWsRootCauseRoute
  AppWWsRuntimeRoute: typeof AppWWsRuntimeRoute
  AppWWsSessionsRoute: typeof AppWWsSessionsRoute
  AppWWsSettingsRoute: typeof AppWWsSettingsRoute
  AppWWsSetupRoute: typeof AppWWsSetupRoute
  AppWWsSimulationsRoute: typeof AppWWsSimulationsRoute
  AppWWsSkillsRoute: typeof AppWWsSkillsRoute
  AppWWsTracesRoute: typeof AppWWsTracesRoute
  AppWWsBranchesBranchIdRoute: typeof AppWWsBranchesBranchIdRoute
  AppWWsContractsContractIdRoute: typeof AppWWsContractsContractIdRoute
  AppWWsLearningChangeIdRoute: typeof AppWWsLearningChangeIdRoute
  AppWWsMemoriesMemoryIdRoute: typeof AppWWsMemoriesMemoryIdRoute
  AppWWsTracesTraceIdRoute: typeof AppWWsTracesTraceIdRoute
}

const AppWWsRouteChildren: AppWWsRouteChildren = {
  AppWWsAccessRoute: AppWWsAccessRoute,
  AppWWsAgentsRoute: AppWWsAgentsRoute,
  AppWWsApprovalsRoute: AppWWsApprovalsRoute,
  AppWWsBranchesRoute: AppWWsBranchesRoute,
  AppWWsCompactionRoute: AppWWsCompactionRoute,
  AppWWsCompanyBrainRoute: AppWWsCompanyBrainRoute,
  AppWWsContextRoute: AppWWsContextRoute,
  AppWWsContractsRoute: AppWWsContractsRoute,
  AppWWsExperimentsRoute: AppWWsExperimentsRoute,
  AppWWsGettingStartedRoute: AppWWsGettingStartedRoute,
  AppWWsGoalsRoute: AppWWsGoalsRoute,
  AppWWsKnowledgeRoute: AppWWsKnowledgeRoute,
  AppWWsLearningRoute: AppWWsLearningRoute,
  AppWWsManifestsRoute: AppWWsManifestsRoute,
  AppWWsMemoriesRoute: AppWWsMemoriesRoute,
  AppWWsNamespacesRoute: AppWWsNamespacesRoute,
  AppWWsOverviewRoute: AppWWsOverviewRoute,
  AppWWsPeopleRoute: AppWWsPeopleRoute,
  AppWWsProjectionsRoute: AppWWsProjectionsRoute,
  AppWWsProvenanceRoute: AppWWsProvenanceRoute,
  AppWWsReplayRoute: AppWWsReplayRoute,
  AppWWsReviewRoute: AppWWsReviewRoute,
  AppWWsRootCauseRoute: AppWWsRootCauseRoute,
  AppWWsRuntimeRoute: AppWWsRuntimeRoute,
  AppWWsSessionsRoute: AppWWsSessionsRoute,
  AppWWsSettingsRoute: AppWWsSettingsRoute,
  AppWWsSetupRoute: AppWWsSetupRoute,
  AppWWsSimulationsRoute: AppWWsSimulationsRoute,
  AppWWsSkillsRoute: AppWWsSkillsRoute,
  AppWWsTracesRoute: AppWWsTracesRoute,
  AppWWsBranchesBranchIdRoute: AppWWsBranchesBranchIdRoute,
  AppWWsContractsContractIdRoute: AppWWsContractsContractIdRoute,
  AppWWsLearningChangeIdRoute: AppWWsLearningChangeIdRoute,
  AppWWsMemoriesMemoryIdRoute: AppWWsMemoriesMemoryIdRoute,
  AppWWsTracesTraceIdRoute: AppWWsTracesTraceIdRoute,
}

const AppWWsRouteWithChildren =
  AppWWsRoute._addFileChildren(AppWWsRouteChildren)

interface AppRouteChildren {
  AppIndexRoute: typeof AppIndexRoute
  AppBillingCancelRoute: typeof AppBillingCancelRoute
  AppBillingCheckoutRoute: typeof AppBillingCheckoutRoute
  AppBillingCreditsRoute: typeof AppBillingCreditsRoute
  AppBillingDetailsRoute: typeof AppBillingDetailsRoute
  AppBillingInvoicesRoute: typeof AppBillingInvoicesRoute
  AppBillingPaymentMethodsRoute: typeof AppBillingPaymentMethodsRoute
  AppBillingPlansRoute: typeof AppBillingPlansRoute
  AppConnectAgentRoute: typeof AppConnectAgentRoute
  AppConnectApiGatewayRoute: typeof AppConnectApiGatewayRoute
  AppConnectImportRoute: typeof AppConnectImportRoute
  AppConnectIngestionRoute: typeof AppConnectIngestionRoute
  AppConnectIntegrationsRoute: typeof AppConnectIntegrationsRoute
  AppConnectMcpRoute: typeof AppConnectMcpRoute
  AppConnectModelsRoute: typeof AppConnectModelsRoute
  AppConnectRoutingRoute: typeof AppConnectRoutingRoute
  AppConnectSourcesRoute: typeof AppConnectSourcesRoute
  AppConnectStorageRoute: typeof AppConnectStorageRoute
  AppConnectWebhooksRoute: typeof AppConnectWebhooksRoute
  AppDevelopDocsRoute: typeof AppDevelopDocsRoute
  AppDevelopKeysRoute: typeof AppDevelopKeysRoute
  AppDevelopPlaygroundRoute: typeof AppDevelopPlaygroundRoute
  AppGovernAuditRoute: typeof AppGovernAuditRoute
  AppGovernDeploymentsRoute: typeof AppGovernDeploymentsRoute
  AppGovernPoliciesRoute: typeof AppGovernPoliciesRoute
  AppGovernPrivacyRoute: typeof AppGovernPrivacyRoute
  AppGovernResidencyRoute: typeof AppGovernResidencyRoute
  AppHelpContactRoute: typeof AppHelpContactRoute
  AppHelpStatusRoute: typeof AppHelpStatusRoute
  AppHelpWhatsNewRoute: typeof AppHelpWhatsNewRoute
  AppMeAccessRoute: typeof AppMeAccessRoute
  AppMeDataRoute: typeof AppMeDataRoute
  AppMeMemoryRoute: typeof AppMeMemoryRoute
  AppMeNotificationPreferencesRoute: typeof AppMeNotificationPreferencesRoute
  AppMeNotificationsRoute: typeof AppMeNotificationsRoute
  AppMeProfileRoute: typeof AppMeProfileRoute
  AppMeSecurityRoute: typeof AppMeSecurityRoute
  AppOrgBudgetsRoute: typeof AppOrgBudgetsRoute
  AppOrgMembersRoute: typeof AppOrgMembersRoute
  AppOrgProductsRoute: typeof AppOrgProductsRoute
  AppOrgRolesRoute: typeof AppOrgRolesRoute
  AppOrgSettingsRoute: typeof AppOrgSettingsRoute
  AppOrgSsoRoute: typeof AppOrgSsoRoute
  AppOrgSupportAccessRoute: typeof AppOrgSupportAccessRoute
  AppOrgUsageRoute: typeof AppOrgUsageRoute
  AppOrgWorkspacesRoute: typeof AppOrgWorkspacesRoute
  AppPlatformOperationsRoute: typeof AppPlatformOperationsRoute
  AppPlatformReleasesRoute: typeof AppPlatformReleasesRoute
  AppPlatformSupportRoute: typeof AppPlatformSupportRoute
  AppWWsRoute: typeof AppWWsRouteWithChildren
  AppBillingIndexRoute: typeof AppBillingIndexRoute
  AppHelpIndexRoute: typeof AppHelpIndexRoute
  AppPlatformIndexRoute: typeof AppPlatformIndexRoute
  AppBillingInvoicesInvoiceIdRoute: typeof AppBillingInvoicesInvoiceIdRoute
  AppConnectSourcesSourceIdRoute: typeof AppConnectSourcesSourceIdRoute
  AppGovernPrivacyCaseIdRoute: typeof AppGovernPrivacyCaseIdRoute
  AppPlatformTenantsTenantIdRoute: typeof AppPlatformTenantsTenantIdRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppIndexRoute: AppIndexRoute,
  AppBillingCancelRoute: AppBillingCancelRoute,
  AppBillingCheckoutRoute: AppBillingCheckoutRoute,
  AppBillingCreditsRoute: AppBillingCreditsRoute,
  AppBillingDetailsRoute: AppBillingDetailsRoute,
  AppBillingInvoicesRoute: AppBillingInvoicesRoute,
  AppBillingPaymentMethodsRoute: AppBillingPaymentMethodsRoute,
  AppBillingPlansRoute: AppBillingPlansRoute,
  AppConnectAgentRoute: AppConnectAgentRoute,
  AppConnectApiGatewayRoute: AppConnectApiGatewayRoute,
  AppConnectImportRoute: AppConnectImportRoute,
  AppConnectIngestionRoute: AppConnectIngestionRoute,
  AppConnectIntegrationsRoute: AppConnectIntegrationsRoute,
  AppConnectMcpRoute: AppConnectMcpRoute,
  AppConnectModelsRoute: AppConnectModelsRoute,
  AppConnectRoutingRoute: AppConnectRoutingRoute,
  AppConnectSourcesRoute: AppConnectSourcesRoute,
  AppConnectStorageRoute: AppConnectStorageRoute,
  AppConnectWebhooksRoute: AppConnectWebhooksRoute,
  AppDevelopDocsRoute: AppDevelopDocsRoute,
  AppDevelopKeysRoute: AppDevelopKeysRoute,
  AppDevelopPlaygroundRoute: AppDevelopPlaygroundRoute,
  AppGovernAuditRoute: AppGovernAuditRoute,
  AppGovernDeploymentsRoute: AppGovernDeploymentsRoute,
  AppGovernPoliciesRoute: AppGovernPoliciesRoute,
  AppGovernPrivacyRoute: AppGovernPrivacyRoute,
  AppGovernResidencyRoute: AppGovernResidencyRoute,
  AppHelpContactRoute: AppHelpContactRoute,
  AppHelpStatusRoute: AppHelpStatusRoute,
  AppHelpWhatsNewRoute: AppHelpWhatsNewRoute,
  AppMeAccessRoute: AppMeAccessRoute,
  AppMeDataRoute: AppMeDataRoute,
  AppMeMemoryRoute: AppMeMemoryRoute,
  AppMeNotificationPreferencesRoute: AppMeNotificationPreferencesRoute,
  AppMeNotificationsRoute: AppMeNotificationsRoute,
  AppMeProfileRoute: AppMeProfileRoute,
  AppMeSecurityRoute: AppMeSecurityRoute,
  AppOrgBudgetsRoute: AppOrgBudgetsRoute,
  AppOrgMembersRoute: AppOrgMembersRoute,
  AppOrgProductsRoute: AppOrgProductsRoute,
  AppOrgRolesRoute: AppOrgRolesRoute,
  AppOrgSettingsRoute: AppOrgSettingsRoute,
  AppOrgSsoRoute: AppOrgSsoRoute,
  AppOrgSupportAccessRoute: AppOrgSupportAccessRoute,
  AppOrgUsageRoute: AppOrgUsageRoute,
  AppOrgWorkspacesRoute: AppOrgWorkspacesRoute,
  AppPlatformOperationsRoute: AppPlatformOperationsRoute,
  AppPlatformReleasesRoute: AppPlatformReleasesRoute,
  AppPlatformSupportRoute: AppPlatformSupportRoute,
  AppWWsRoute: AppWWsRouteWithChildren,
  AppBillingIndexRoute: AppBillingIndexRoute,
  AppHelpIndexRoute: AppHelpIndexRoute,
  AppPlatformIndexRoute: AppPlatformIndexRoute,
  AppBillingInvoicesInvoiceIdRoute: AppBillingInvoicesInvoiceIdRoute,
  AppConnectSourcesSourceIdRoute: AppConnectSourcesSourceIdRoute,
  AppGovernPrivacyCaseIdRoute: AppGovernPrivacyCaseIdRoute,
  AppPlatformTenantsTenantIdRoute: AppPlatformTenantsTenantIdRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface PublicRouteChildren {
  PublicAcceptInviteRoute: typeof PublicAcceptInviteRoute
  PublicChooseOrgRoute: typeof PublicChooseOrgRoute
  PublicCreateOrgRoute: typeof PublicCreateOrgRoute
  PublicForgotPasswordRoute: typeof PublicForgotPasswordRoute
  PublicLegalRoute: typeof PublicLegalRoute
  PublicLoginRoute: typeof PublicLoginRoute
  PublicMaintenanceRoute: typeof PublicMaintenanceRoute
  PublicMfaRoute: typeof PublicMfaRoute
  PublicResetPasswordRoute: typeof PublicResetPasswordRoute
  PublicSessionExpiredRoute: typeof PublicSessionExpiredRoute
  PublicSignupRoute: typeof PublicSignupRoute
  PublicSsoRoute: typeof PublicSsoRoute
  PublicStatusRoute: typeof PublicStatusRoute
  PublicVerifyEmailRoute: typeof PublicVerifyEmailRoute
}

const PublicRouteChildren: PublicRouteChildren = {
  PublicAcceptInviteRoute: PublicAcceptInviteRoute,
  PublicChooseOrgRoute: PublicChooseOrgRoute,
  PublicCreateOrgRoute: PublicCreateOrgRoute,
  PublicForgotPasswordRoute: PublicForgotPasswordRoute,
  PublicLegalRoute: PublicLegalRoute,
  PublicLoginRoute: PublicLoginRoute,
  PublicMaintenanceRoute: PublicMaintenanceRoute,
  PublicMfaRoute: PublicMfaRoute,
  PublicResetPasswordRoute: PublicResetPasswordRoute,
  PublicSessionExpiredRoute: PublicSessionExpiredRoute,
  PublicSignupRoute: PublicSignupRoute,
  PublicSsoRoute: PublicSsoRoute,
  PublicStatusRoute: PublicStatusRoute,
  PublicVerifyEmailRoute: PublicVerifyEmailRoute,
}

const PublicRouteWithChildren =
  PublicRoute._addFileChildren(PublicRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  PublicRoute: PublicRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
